<template>
  <v-form enctype="multipart/form-data" ref="tabla-detalles">
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <!-- Toolbar Header -->
      <v-toolbar color="secondary" dark flat class="table-header-toolbar px-2 px-sm-3">
        <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-clipboard-list-outline</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              Detalle de Inspecciones
            </div>
          </div>
          <div class="d-flex align-center flex-wrap gap-1 flex-shrink-0">
            <v-chip
              v-if="Identificador"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1"
            >
              <v-icon left size="14" color="secondary">mdi-pound</v-icon>
              ID: {{ Identificador }}
            </v-chip>
            <v-chip
              v-if="Vehiculo && (Vehiculo.placa || Vehiculo.codigo)"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1"
            >
              <v-icon left size="14" color="secondary">mdi-car</v-icon>
              {{ Vehiculo.placa || Vehiculo.codigo }}
            </v-chip>
            <v-chip
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1"
            >
              <v-icon left size="14" color="secondary">mdi-tire</v-icon>
              {{ Inspecciones ? Inspecciones.length : 0 }}
            </v-chip>
          </div>
        </div>
        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <v-btn
            icon
            dark
            small
            @click="$emit('cerrarModalDetallesPorIdentificador')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>

      <v-card-text class="pa-2 pa-sm-4">
        <!-- Barra de opciones superior: Título de sección y Botón de Exportar -->
        <div
          v-if="mostrarBotonEliminar == false && tieneRegistros"
          class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3 px-1"
        >
          <div class="d-flex align-center">
            <v-icon small color="primary" class="mr-1"
              >mdi-format-list-checks</v-icon
            >
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Neumáticos Registrados en esta Inspección
            </span>
          </div>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                height="36"
                class="px-3 font-weight-bold text-none rounded-lg elevation-1"
                :loading="loader"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left size="18">mdi-file-excel-box</v-icon>
                {{ extension2 ? extension2 : "Exportar" }}
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense class="rounded-lg py-1">
              <v-list-item
                v-for="opt in opcionesAexportar"
                :key="opt.id"
                @click="onSelectExport(opt.text)"
                class="px-3"
              >
                <v-list-item-icon class="mr-2 my-1">
                  <v-icon small :color="opt.id === 1 ? 'success' : 'primary'">
                    {{ opt.id === 1 ? "mdi-file-excel" : "mdi-file-delimited" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-caption font-weight-medium">
                  {{ opt.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <!-- Indicador de desplazamiento horizontal en celular -->
        <div
          v-if="tieneRegistros"
          class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-1"
        >
          <v-icon x-small color="primary" class="mr-1">
            mdi-gesture-swipe-horizontal
          </v-icon>
          <span>Desliza horizontalmente para ver todos los datos</span>
        </div>

        <!-- Tabla Estilizada con Scroll y Header Oscuro (solo si hay registros) -->
        <div
          v-if="tieneRegistros"
          class="details-table-wrapper table-responsive-wrapper"
        >
          <table class="details-modern-table" :id="clase_table">
            <thead>
              <!-- Fila 1: Encabezados Principales -->
              <tr class="header-main-row">
                <th class="head-cell" rowspan="2">Opciones</th>
                <th class="head-cell" rowspan="2">Pos</th>
                <th class="head-cell" rowspan="2">Serie del neumático</th>
                <th class="head-cell" rowspan="2">Marca</th>
                <th class="head-cell" rowspan="2">Modelo</th>
                <th class="head-cell" rowspan="2">Medida</th>
                <th class="head-cell" rowspan="2">Diseño</th>
                <th class="head-cell" rowspan="2">Eje</th>
                <th class="head-cell" rowspan="2">Condición</th>
                <th class="head-cell" rowspan="2">Número Reencauche</th>
                <th class="head-cell" rowspan="2">Empresa reencauchadora</th>
                <th class="head-cell" rowspan="2">Fecha Reencauche</th>
                <th class="head-cell" rowspan="2">Presión</th>
                <th class="head-cell" rowspan="2">Tipo Presión</th>
                <th class="head-cell head-group" colspan="3">Tapa de Pitón</th>
                <th class="head-cell head-group" colspan="3">
                  Profundidad de Rodado (mm)
                </th>
                <th class="head-cell" rowspan="2">Duales mal hermanados</th>
                <th class="head-cell" rowspan="2">Separación entre duales</th>
                <th
                  class="head-cell head-group"
                  :colspan="ListaTodasObservaciones.length || 4"
                >
                  Observaciones
                </th>
                <th class="head-cell head-group" colspan="2">Tuercas</th>
                <th class="head-cell" rowspan="2">Estado</th>
                <th class="head-cell" rowspan="2">Tipo costo</th>
                <th class="head-cell" rowspan="2">
                  {{ unidadAbrev }} instalación
                </th>
                <th class="head-cell" rowspan="2">
                  {{ unidadAbrev }} inspección
                </th>
                <th class="head-cell" rowspan="2">
                  {{ unidadAbrev }} recorrido
                </th>
                <th class="head-cell" rowspan="2">
                  {{ unidadAbrev }} proyectado
                </th>
                <th class="head-cell" rowspan="2">Recomendación</th>
              </tr>
              <!-- Fila 2: Sub-encabezados -->
              <tr class="header-sub-row">
                <!-- Tapa de Pitón (3) -->
                <th class="subhead-cell">Tapa Pitón</th>
                <th class="subhead-cell">Accesibilidad</th>
                <th class="subhead-cell">Motivo Inaccesibilidad</th>
                <!-- Profundidad (3) -->
                <th class="subhead-cell">Izquierdo</th>
                <th class="subhead-cell">Medio</th>
                <th class="subhead-cell">Derecho</th>
                <!-- Observaciones dinámicas -->
                <th
                  v-for="(obs, idx) in ListaTodasObservaciones"
                  :key="'obs_head_' + idx"
                  class="subhead-cell"
                >
                  {{ obs.label }}
                </th>
                <!-- Tuercas (2) -->
                <th class="subhead-cell">Estado</th>
                <th class="subhead-cell">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in Inspecciones"
                :key="index"
                class="data-row"
              >
                <!-- Opciones -->
                <td class="cell-center">
                  <div class="d-flex align-center justify-center gap-1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          height="24"
                          width="24"
                          color="blue lighten-2"
                          fab
                          x-small
                          dark
                          class="action-btn elevation-1"
                          @click="editarItem(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon x-small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="mostrarBotonEliminar == true">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          height="24"
                          width="24"
                          color="red lighten-1"
                          fab
                          x-small
                          dark
                          class="action-btn elevation-1 ml-1"
                          @click="eliminarItem(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon x-small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </div>
                </td>
                <td class="cell-center font-weight-bold">
                  {{ item.d_posicion }}
                </td>
                <td
                  class="cell-center font-weight-bold font-mono text--primary"
                >
                  {{ item.num_serie }}
                </td>
                <td class="cell-center">{{ item.marca }}</td>
                <td class="cell-center">{{ item.modelo }}</td>
                <td class="cell-center">{{ item.medida }}</td>
                <td class="cell-center">{{ item.disenio }}</td>
                <td class="cell-center">{{ item.eje }}</td>
                <td class="cell-center">{{ item.condicion }}</td>
                <td class="cell-center">{{ item.cantidad_reencauche }}</td>
                <td class="cell-center">{{ item.empresa_reencauche }}</td>
                <td class="cell-center">{{ item.fecha_reencauche }}</td>
                <td class="cell-center font-weight-medium">
                  {{ item.presion }}
                </td>
                <td class="cell-center">{{ item.tipo_presion }}</td>
                <td class="cell-center">{{ item.d_valvula }}</td>
                <td class="cell-center">{{ item.d_accesibilidad }}</td>
                <td class="cell-center">{{ item.d_motivo_inaccesibilidad }}</td>
                <td class="cell-center font-weight-medium">
                  {{ item.exterior }}
                </td>
                <td class="cell-center font-weight-medium">{{ item.medio }}</td>
                <td class="cell-center font-weight-medium">
                  {{ item.interior }}
                </td>
                <td class="cell-center">{{ item.resultado }}</td>
                <td class="cell-center">{{ item.sep_duales }}</td>
                <td
                  v-for="(obs, idx) in ListaTodasObservaciones"
                  :key="'obs_cell_' + idx"
                  class="cell-center"
                >
                  {{ getValorObservacion(item, obs) }}
                </td>
                <td class="cell-center">{{ item.d_tuercaestado }}</td>
                <td class="cell-center">{{ item.tuercacantidad }}</td>
                <td class="cell-center">{{ item.estado }}</td>
                <td class="cell-center">{{ item.tipo_costo }}</td>
                <td class="cell-center">{{ item.km_instalacion }}</td>
                <td class="cell-center">{{ item.km_inspeccion }}</td>
                <td class="cell-center">{{ item.km_recorrido }}</td>
                <td class="cell-center">{{ item.km_proyectado }}</td>
                <td class="cell-center">{{ item.recomendacion }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Estado vacío: No hay registros de inspección -->
        <div v-else class="empty-state-container">
          <v-icon size="56" color="grey lighten-1" class="d-block mx-auto mb-3">
            mdi-clipboard-text-off-outline
          </v-icon>

          <div class="text-caption grey--text text--darken-1">
            No se encontraron neumáticos registrados para esta inspección.
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Modal Confirmación Eliminar -->
    <v-dialog v-model="dialog" persistent max-width="450px">
      <v-card class="rounded-lg overflow-hidden elevation-4">
        <v-toolbar height="50" color="error" dark flat class="px-3">
          <v-icon left>mdi-alert-circle-outline</v-icon>
          <span class="text-subtitle-1 font-weight-bold"
            >Confirmar Eliminación</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-5 text-center">
          <v-avatar color="red lighten-5" size="64" class="mb-3">
            <v-icon color="error" size="36">mdi-trash-can-outline</v-icon>
          </v-avatar>
          <div class="text-body-1 font-weight-medium text--primary mb-1">
            ¿Desea eliminar esta inspección?
          </div>
          <div class="text-caption grey--text text--darken-1">
            Esta acción no se puede deshacer y removerá la inspección del
            neumático seleccionado.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="bg-actions pa-3 px-4 d-flex justify-end">
          <v-btn
            text
            color="grey darken-1"
            class="text-capitalize"
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            class="text-capitalize px-4 rounded-lg elevation-1 ml-2"
            @click="confirmar()"
          >
            <v-icon left small>mdi-delete</v-icon>
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import global from "../../global";
// import axios from "axios";
import { axios2 as axios } from "@/interceptor/useApi";
export default {
  props: [
    "Inspecciones",
    "mostrarBotonEliminar",
    "Identificador",
    "clase",
    "PermisoEditar",
    "Vehiculo",
  ],
  data() {
    return {
      dialog: false,
      itemSelected: {},
      opcionesAexportar: [
        {
          id: 1,
          text: "Exportar Excel",
        },
        {
          id: 2,
          text: "Exportar CSV",
        },
      ],
      loader: false,
      extension2: "",
      clase_table: "table1",
    };
  },
  created() {
    if (!this.Observaciones || this.Observaciones.length === 0) {
      this.recargarObservaciones();
    }
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    ...mapState("inspeccion", ["Observaciones"]),
    /**
     * Verifica si existen registros de inspección para mostrar la tabla.
     * Retorna true solo si Inspecciones es un array con al menos un elemento.
     */
    tieneRegistros() {
      return Array.isArray(this.Inspecciones) && this.Inspecciones.length > 0;
    },
    ListaTodasObservaciones() {
      return this.Observaciones.map((grupo) => ({
        identificador: grupo.tipo,
        label: grupo.nombre || grupo.tipo,
        codigo: grupo.codigo || "obs",
      }));
    },
    unidadAbrev() {
      let tc = null;
      if (
        this.Vehiculo &&
        this.Vehiculo.tipo_costo !== undefined &&
        this.Vehiculo.tipo_costo !== null
      ) {
        tc = this.Vehiculo.tipo_costo;
      } else if (
        this.Inspecciones &&
        this.Inspecciones.length > 0 &&
        this.Inspecciones[0].tipo_costo !== undefined &&
        this.Inspecciones[0].tipo_costo !== null
      ) {
        tc = this.Inspecciones[0].tipo_costo;
      }

      const isHoras =
        tc == 2 || tc === "2" || tc === "Horas" || tc === "H" || tc === "Hr";
      const res = isHoras ? "Hrs" : "Km";
      console.log(
        "8. [detalles.vue] unidadAbrev -> Vehiculo prop:",
        this.Vehiculo,
        "Inspecciones prop:",
        this.Inspecciones,
        "tc hallado:",
        tc,
        "resultado:",
        res,
      );
      return res;
    },
  },
  methods: {
    ...mapActions("inspeccion", ["recargarObservaciones"]),
    getValorObservacion(item, obs) {
      if (!item || !obs) return "Sin observación";

      const idLower = (obs.identificador || "").toLowerCase();
      const idUpper = (obs.identificador || "").toUpperCase();
      const labelUpper = (obs.label || "").toUpperCase();
      const codigoLower = (obs.codigo || "obs").toLowerCase();

      // 1. Chequear d_obs_di, d_obs_pr, d_obs_ff, etc.
      const keyDynamic = "d_" + codigoLower + "_" + idLower;
      if (
        item[keyDynamic] !== undefined &&
        item[keyDynamic] !== null &&
        item[keyDynamic] !== ""
      ) {
        return item[keyDynamic];
      }

      // 2. Chequear d_di, d_pr, d_ff, etc.
      const keyShort = "d_" + idLower;
      if (
        item[keyShort] !== undefined &&
        item[keyShort] !== null &&
        item[keyShort] !== ""
      ) {
        return item[keyShort];
      }

      // 3. Chequear si se pasó el valor directamente en item[identificador]
      if (
        item[obs.identificador] !== undefined &&
        item[obs.identificador] !== null &&
        item[obs.identificador] !== ""
      ) {
        return item[obs.identificador];
      }

      // 4. Chequear en el string otros (para observaciones simples seleccionadas)
      if (item.otros && typeof item.otros === "string") {
        const otrosArr = item.otros
          .split(",")
          .map((s) => s.trim().toUpperCase());
        if (otrosArr.includes(labelUpper) || otrosArr.includes(idUpper)) {
          return "SI";
        }
      }
      return "Sin observación";
    },
    editarItem: function (item) {
      //emite al componente tabla de la inspeccion
      this.$emit("editarInspeccionParcial", item);
    },
    eliminarItem: function (item) {
      this.dialog = true;
      this.itemSelected = item;
    },
    confirmar: function () {
      this.dialog = false;
      this.$emit("eliminarInspeccionParcial", this.itemSelected.id);
    },
    async exportarAExcel2() {
      try {
        this.loader = true;
        const url =
          global.ruta_api +
          "excel/reporteinspecciones?" +
          global._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            id_usuario: localStorage.getItem("id"),
            extension: this.extension2,
            identificador: this.Identificador,
          });

        await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        })
          .then(async (response) => {
            this.loader = false;
            var nombre_archivo = response.headers["nombre-archivo"];
            if (response.data.type == "text/html") {
              // no es excel, probablemente es json con un mensaje de error
              const res = JSON.parse(await response.data.text());
              if (!res.exito) {
                alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
              }
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", nombre_archivo);
              document.body.appendChild(link);
              link.click();
              this.extension2 = "";
            }
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
          });
      } catch (error) {
        console.log(error);
      }
    },
    onSelectExport(tipo) {
      this.extension2 = tipo;
      this.exportarAExcel2();
    },
  },
  mounted() {
    if (this.clase != undefined) {
      this.clase_table = this.clase;
    }
  },
};
</script>

<style scoped>
/* Toolbar Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.bg-actions {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.details-table-wrapper {
  width: 100%;
  max-height: calc(85vh - 190px);
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #ffffff;
  -webkit-overflow-scrolling: touch;
}

.details-table-wrapper::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.details-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.details-table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.details-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.details-modern-table {
  width: 100%;
  min-width: 1900px;
  border-collapse: separate;
  border-spacing: 0;
  font-family: inherit;
  font-size: 0.78rem;
}

/* Sticky primera columna (Opciones) */
.header-main-row th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 6 !important;
  background-color: #424242 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15) !important;
}

.cell-center:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background-color: #ffffff !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.06) !important;
}

.data-row:nth-child(even) .cell-center:first-child {
  background-color: #f8fafc !important;
}

.data-row:hover .cell-center:first-child {
  background-color: #eff6ff !important;
}

/* Header principal */
.header-main-row th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.76rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.4px !important;
  padding: 9px 12px !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
  position: sticky;
  top: 0;
  z-index: 5;
}

/* Sub-header de agrupaciones */
.header-sub-row th {
  background-color: #525252 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 0.72rem !important;
  padding: 6px 10px !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-bottom: 2px solid #212121 !important;
  position: sticky;
  top: 36px;
  z-index: 4;
}

/* Celdas del cuerpo */
.cell-center {
  padding: 7px 10px !important;
  border-bottom: 1px solid #e2e8f0 !important;
  border-right: 1px solid #f1f5f9 !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  color: #334155;
  font-size: 0.78rem;
}

.data-row:nth-child(even) {
  background-color: #f8fafc;
}

.data-row:hover {
  background-color: #eff6ff !important;
  transition: background-color 0.15s ease-in-out;
}

.font-mono {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.empty-state-container {
  text-align: center;
  padding: 48px 24px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background-color: #f8fafc;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.72rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .header-main-row th {
    font-size: 0.7rem !important;
    padding: 7px 8px !important;
  }

  .header-sub-row th {
    font-size: 0.68rem !important;
    padding: 5px 6px !important;
  }

  .cell-center {
    font-size: 0.74rem !important;
    padding: 5px 7px !important;
  }
}
</style>
